'use client';

import React from 'react';
import HeroTile from '@/components/organisms/hero-tile';
import { resolveReference } from '@/utils/lib/resolve-reference';
import { useTranslations } from 'use-intl';
import useAccount from '@/lib/hooks/useAccount';
import { TasticProps } from '../types';
import { Props } from './types';

const HeroTileTastic = ({ data }: any) => {
  const translate = useTranslations();

  const { account } = useAccount();

  return (
    <HeroTile
      data={data?.data?.dataSource}
    />
  );
};

export default HeroTileTastic;
